import { BodyStyles } from '../../../../api-client/enums'
import { Button } from '../../../../components/button'
import { Mobile } from '../../../../components/media'
import ListItemCheckbox from './list-item-checkbox'

export default function BodyStyleFilter({ checkedStyles, onChange, handleFilterToggle }) {
  return (
    <div className='wrapper'>
      <p className='filterLabel'>Select body style</p>
      <ul className='bodyStylesList flex flexWrap justifyBetween'>
        {BodyStyles.map(({ label, value }) => (
          <ListItemCheckbox
            key={label}
            checked={!!checkedStyles[value]}
            value={value}
            onChange={onChange}
          >
            {label}
          </ListItemCheckbox>
        ))}
      </ul>
      <Mobile>
        <div className='applyButton'>
          <Button onClick={() => handleFilterToggle('bodyStyle')}>Apply</Button>
        </div>
      </Mobile>

      <style jsx>{`
        .applyButton {
          position: fixed;
          left: calc(50% - 46.9px);
          top: 14rem;
        }
        .wrapper {
          padding: 2rem;
          border-radius: 1rem;
          background: #fff;
          box-shadow: 0 0.3rem 0.6rem rgba(0, 0, 0, 0.16);
          color: var(--secondary-text-color);
        }

        .filterLabel {
          font-size: 1.6rem;
          font-weight: 700;
        }

        .bodyStylesList {
          overflow: hidden;
          margin-top: 8rem;

          :global(li) {
            max-width: 18.8rem;
            width: 100%;
          }
        }

        @media (max-width: 1024px) {
          .wrapper {
            max-width: 100%;
            padding: 3rem;
            box-shadow: none;
            border-radius: 0;
          }

          .filterLabel {
            font-size: 1.2rem;
          }

          .bodyStylesList {
            display: block;

            :global(li) {
              max-width: 100%;
            }
          }
        }
      `}</style>
    </div>
  )
}
